define("ROOM4.CCAProductGallery.CCAProductGallery.PackageItemQuote.View", [
  "room4_ccaproductgallery_package_item_quote.tpl",
  "Backbone",
], function (
  room4_ccaproductgallery_package_item_quote_tpl,
  Backbone
) {
  "use strict";

  return Backbone.View.extend({
    template: room4_ccaproductgallery_package_item_quote_tpl,

    events: {
      "click .ccaproductgallery-package-add-to-quote": "addToQuote",
    },

    initialize: function initialize() {
      this.model.on(
        "change:isAddingToQuote change:isAddedToQuote",
        this.render,
        this
      );
    },

    destroy: function destroy() {
      this.model.off(null, null, this);

      return this._destroy();
    },

    addToQuote: function addToQuote(event) {
      event.preventDefault();
      this.model.addToQuote();
    },

    getContext: function getContext() {
      return {
        itemId: this.model.get("itemId"),
        isQuotable: this.model.isQuotable(),
        isAddingToQuote: !!this.model.get("isAddingToQuote"),
        isAddedToQuote: !!this.model.get("isAddedToQuote"),
      };
    },
  });
});
